export default "<abw-page-builder-label-design [model]=\"model\" [value]=\"model.value\"></abw-page-builder-label-design>";